// src/pages/geral/CidadeSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import { useCidades } from '../../contexts/geral/CidadeContext';
import ModalTable from '../../components/modalForm/ModalTable';
import LazyLoading from '../../components/modalForm/LazyLoading';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';

import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const CidadeSearch = ({ show, onHide, onSelectCidade }) => {
    const { cidades } = useCidades();
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');

    const inputRef = useRef(null);

    const removeAccents = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    };

    useEffect(() => {
        if (show) {
            setFilter('');

            if (inputRef.current) inputRef.current.focus();
        }
    }, [show]);

    if (!show) return null;

    const normalizedFilter = removeAccents(filter);

    const filteredCidades = cidades.filter(cidade => {
        const normalizedNome = removeAccents(cidade.nome);
        const normalizedUF = cidade.uf?.toLowerCase();
        return normalizedNome.includes(normalizedFilter) ||
               normalizedUF?.includes(normalizedFilter);
    });

    const sortedCidades = [...filteredCidades].sort((a, b) => {
        let valueA, valueB;
        if (sortField === 'id') {
            valueA = a.id;
            valueB = b.id;
            if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
            if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        } else {
            valueA = removeAccents(a[sortField]?.toString() || '');
            valueB = removeAccents(b[sortField]?.toString() || '');
            if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
            if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (cidade) => {
        onSelectCidade(cidade);
        onHide();
    };

    return (
        <ModalContainer largura='700px' show={show} variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar Cidade" onHide={onHide} />

            <ModalBody>
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por nome ou UF..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading items={sortedCidades} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('id')}
                                    className="btn btn-link p-0 fw-bold"
                                    tabIndex={0}
                                 type="button">
                                    Id {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" style={{ width: '50%' }} aria-sort={sortField === 'nome' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('nome')}
                                    className="btn btn-link p-0 fw-bold"
                                    tabIndex={0}
                                 type="button">
                                    Nome {sortField === 'nome' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle" style={{ width: '10%' }} aria-sort={sortField === 'uf' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    onClick={() => handleSort('uf')}
                                    className="btn btn-link p-0 fw-bold"
                                    tabIndex={0}
                                 type="button">
                                    UF {sortField === 'uf' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" style={{ width: '30%' }}>
                                Selecionar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((cidade) => (
                            <tr key={cidade?.id} onDoubleClick={() => handleDoubleClick(cidade)}>
                                <td className="text-center align-middle">{cidade?.id}</td>
                                <td className="text-start align-middle">{cidade?.nome}</td>
                                <td className="text-center align-middle">{cidade?.uf}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" style={{ padding: '2px 6px' }} onClick={() => {
                                            onSelectCidade(cidade);
                                            onHide();
                                        }} label={cidade?.nome} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>

            <ModalFooter>

                <ModalActionButton className="btn btn-secondary btn-sm" onClick={onHide} action="close">Fechar</ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default CidadeSearch;